<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 20 20"
  >
    <path
      fill="currentColor"
      d="M16.7 10c0-2.8-1.7-5.1-4.1-6.2l-.7 1.6a5 5 0 0 1 0 9.2l.7 1.6c2.4-1 4-3.4 4-6.2m-3.4 0q-.1-2.2-2-3l-.7 1.5a1.7 1.7 0 0 1 0 3l.7 1.6q1.9-.9 2-3.1m.5-9.2-.6 1.5a8.3 8.3 0 0 1 0 15.4l.6 1.5a10 10 0 0 0 0-18.4M0 5.8v8.4h3.3L9.2 20V0L3.3 5.8z"
    />
  </svg>
</template>
